// Module
var code = "<svg width=\"29\" height=\"29\" fill=\"none\" viewBox=\"0 0 29 29\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.158 14.008H9M14.256 9l-5.25 5 5.25 5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg> ";
// Exports
module.exports = code;